import React, { useState, useEffect } from 'react';
import { db } from '../lib/supabase';

export default function UserDashboard({ lang, user, onNavigate }) {
  const ar = lang === 'ar';
  const L = (fr, a) => ar ? a : fr;
  const [tab, setTab] = useState('analyses');
  const [analyses, setAnalyses] = useState([]);
  const [verifications, setVerifications] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedVerif, setExpandedVerif] = useState(null);

  const localHistory = JSON.parse(localStorage.getItem('tidjarai_history') || localStorage.getItem('tradeflow_history') || '[]');

  useEffect(() => {
    const email = user?.email;
    if (!email) { setLoading(false); return; }

    async function load() {
      try {
        const [al, q, vl] = await Promise.all([
          db.from('analysis_log').select('*').eq('user_email', email).order('created_at', { ascending: false }).limit(50),
          db.from('quote_requests').select('*, quote_responses(*, freight_forwarders(company_name,email,phone))').eq('requester_email', email).order('created_at', { ascending: false }),
          db.from('verification_sessions').select('*').eq('user_email', email).order('created_at', { ascending: false }).limit(20),
        ]);
        setAnalyses(al.data || []);
        setQuotes(q.data || []);
        setVerifications(vl.data || []);
      } catch (e) { console.warn('[Dashboard]', e); }
      setLoading(false);
    }
    load();
  }, [user]);

  const tabs = [
    { id: 'analyses', icon: '🔍', label: L('Mes analyses', 'تحليلاتي') },
    { id: 'docs', icon: '📄', label: L('Vérifications docs', 'تحقق الوثائق') },
    { id: 'devis', icon: '📋', label: L('Mes demandes devis', 'طلبات عروض الأسعار') },
    { id: 'actions', icon: '⚡', label: L('Actions rapides', 'إجراءات سريعة') },
  ];

  return (
    <div>
      {/* Welcome */}
      <div className="card" style={{ background: 'linear-gradient(135deg, rgba(124,58,237,0.1), rgba(16,185,129,0.05))', border: '1px solid rgba(124,58,237,0.2)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ fontSize: '1rem', marginBottom: '0.2rem' }}>{L('Bonjour 👋', 'مرحباً 👋')}</h3>
            <p style={{ fontSize: '0.82rem', color: 'var(--muted)' }}>{user?.email}</p>
          </div>
          <span className="badge badge-green" style={{ padding: '0.3rem 0.7rem' }}>{L('Connecté', 'متصل')}</span>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '0.3rem', marginBottom: '1rem', overflowX: 'auto' }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding: '0.5rem 1rem', borderRadius: 10, border: `1px solid ${tab === t.id ? '#7C3AED' : 'var(--border)'}`, background: tab === t.id ? 'rgba(124,58,237,0.15)' : 'transparent', color: tab === t.id ? '#818cf8' : 'var(--muted)', fontSize: '0.82rem', fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' }}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {/* Analyses */}
      {tab === 'analyses' && (
        <div className="card">
          <div className="card-title">🔍 {L('Mes analyses', 'تحليلاتي')} ({analyses.length || localHistory.length})</div>
          {loading && <div style={{ textAlign:'center', padding:'1rem', color:'var(--muted)' }}><span className="spinner"/> {L('Chargement...','جاري التحميل...')}</div>}
          {!loading && analyses.length === 0 && localHistory.length === 0 ? (
            <div style={{ textAlign:'center', padding:'2rem', color:'var(--muted)' }}>
              <div style={{ fontSize:'2rem', marginBottom:'0.5rem' }}>📭</div>
              <p>{L('Aucune analyse encore.','لا توجد تحليلات بعد.')}</p>
              <button className="btn btn-primary" style={{ width:'auto', marginTop:'0.8rem' }} onClick={() => onNavigate('analyse')}>{L('🔍 Faire une analyse','🔍 إجراء تحليل')}</button>
            </div>
          ) : (<div>
            {/* DB analyses */}
            {analyses.map((a, i) => (
              <div key={'db-'+i} style={{ padding:'0.7rem 0', borderBottom:'1px solid var(--border)' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:'0.5rem', flexWrap:'wrap' }}>
                  <div style={{ flex:1, minWidth:200 }}>
                    <div style={{ fontWeight:600, fontSize:'0.88rem', marginBottom:'0.2rem' }}>{a.description}</div>
                    <div style={{ display:'flex', gap:'0.3rem', flexWrap:'wrap' }}>
                      <span className={`badge ${a.type==='import'?'badge-blue':'badge-green'}`}>{a.type}</span>
                      <span className="badge badge-blue">{a.hs_code}</span>
                      {a.country && <span style={{ fontSize:'0.7rem', color:'var(--muted)' }}>{a.country}</span>}
                      <span style={{ fontSize:'0.7rem', color:'var(--muted)' }}>{new Date(a.created_at).toLocaleDateString('fr-FR')}</span>
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:'0.3rem', flexShrink:0 }}>
                    <button className="btn btn-outline" style={{ padding:'0.3rem 0.6rem', fontSize:'0.72rem' }} onClick={() => onNavigate('verify')}>🔍 {L('Vérifier','تحقق')}</button>
                    <button className="btn btn-outline" style={{ padding:'0.3rem 0.6rem', fontSize:'0.72rem' }} onClick={() => onNavigate('devis')}>📋 {L('Devis','عرض')}</button>
                  </div>
                </div>
              </div>
            ))}
            {/* Local history fallback */}
            {analyses.length === 0 && localHistory.map((h, i) => (
              <div key={'local-'+i} style={{ padding:'0.7rem 0', borderBottom:'1px solid var(--border)', cursor:'pointer' }} onClick={() => onNavigate('analyse', h.form, h)}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:'0.5rem', flexWrap:'wrap' }}>
                  <div style={{ flex:1, minWidth:200 }}>
                    <div style={{ fontWeight:600, fontSize:'0.88rem', marginBottom:'0.2rem' }}>{h.description}</div>
                    <div style={{ display:'flex', gap:'0.3rem', flexWrap:'wrap' }}>
                      <span className="badge badge-blue">{h.code_sh}</span>
                      {h.result && <span className="badge badge-green">{L('Résultats sauvés','نتائج محفوظة')}</span>}
                      <span style={{ fontSize:'0.7rem', color:'var(--muted)' }}>{new Date(h.date).toLocaleDateString('fr-FR')}</span>
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:'0.3rem', flexShrink:0 }}>
                    <button className="btn btn-outline" style={{ padding:'0.3rem 0.6rem', fontSize:'0.72rem' }} onClick={e => { e.stopPropagation(); onNavigate('verify', null, h); }}>🔍 {L('Vérifier','تحقق')}</button>
                    <button className="btn btn-outline" style={{ padding:'0.3rem 0.6rem', fontSize:'0.72rem' }} onClick={e => { e.stopPropagation(); onNavigate('devis'); }}>📋 {L('Devis','عرض')}</button>
                  </div>
                </div>
              </div>
            ))}
          </div>)}
        </div>
      )}

      {/* Doc verifications */}
      {tab === 'docs' && (
        <div className="card">
          <div className="card-title">📄 {L('Vérifications documentaires', 'التحقق من الوثائق')} ({verifications.length})</div>
          {verifications.length === 0 ? (
            <div style={{ textAlign:'center', padding:'2rem', color:'var(--muted)' }}>
              <div style={{ fontSize:'2rem', marginBottom:'0.5rem' }}>📄</div>
              <p>{L('Aucune vérification encore.','لا توجد عمليات تحقق بعد.')}</p>
              <button className="btn btn-primary" style={{ width:'auto', marginTop:'0.8rem' }} onClick={() => onNavigate('verify')}>{L('🔍 Vérifier des documents','🔍 تحقق من الوثائق')}</button>
            </div>
          ) : (
            <div>
              {verifications.map((v, i) => (
                <div key={i} style={{ padding:'0.7rem 0', borderBottom:'1px solid var(--border)', cursor:'pointer' }}
                  onClick={() => setExpandedVerif(expandedVerif === i ? null : i)}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <div>
                      <div style={{ fontWeight:600, fontSize:'0.85rem' }}>{v.product_description || L('Vérification','تحقق')}</div>
                      <div style={{ display:'flex', gap:'0.3rem', flexWrap:'wrap', marginTop:'0.2rem' }}>
                        {v.hs_code && <span className="badge badge-blue">{v.hs_code}</span>}
                        {v.origin_country && <span className="badge badge-green">{v.origin_country}</span>}
                        <span className={`badge ${v.status==='completed'?'badge-green':'badge-yellow'}`}>{v.status}</span>
                        <span style={{ fontSize:'0.7rem', color:'var(--muted)' }}>{new Date(v.created_at).toLocaleDateString('fr-FR')}</span>
                      </div>
                    </div>
                    <span style={{ color:'var(--muted)', fontSize:'1.2rem' }}>{expandedVerif === i ? '▼' : '▶'}</span>
                  </div>
                  {/* Expanded details */}
                  {expandedVerif === i && v.results && (
                    <div style={{ marginTop:'0.6rem', padding:'0.6rem', background:'rgba(255,255,255,0.02)', borderRadius:10, border:'1px solid var(--border)' }} onClick={e => e.stopPropagation()}>
                      {(Array.isArray(v.results) ? v.results : []).map((r, j) => (
                        <div key={j} style={{ marginBottom:'0.6rem' }}>
                          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'0.3rem' }}>
                            <strong style={{ fontSize:'0.82rem' }}>📎 {r.fileName || r.documentType || `Document ${j+1}`}</strong>
                            <span className={`badge ${r.overallStatus==='CONFORME'?'badge-green':r.overallStatus==='ANOMALIES_MINEURES'?'badge-yellow':'badge-red'}`}>{r.overallStatus}</span>
                          </div>
                          {r.checks?.map((c, k) => (
                            <div key={k} style={{ display:'flex', gap:'0.5rem', fontSize:'0.75rem', padding:'0.2rem 0', borderBottom:'1px solid rgba(255,255,255,0.03)' }}>
                              <span>{c.status==='OK'?'✅':c.status==='MANQUANT'?'🚨':'⚠️'}</span>
                              <span style={{ flex:1 }}>{c.requirement}</span>
                              {c.correctionNeeded && <span style={{ color:'#f59e0b', fontSize:'0.7rem' }}>{c.correctionNeeded}</span>}
                            </div>
                          ))}
                          {r.actionRequired && <div style={{ fontSize:'0.75rem', color:'#ef4444', marginTop:'0.3rem', fontWeight:600 }}>⚠️ {r.actionRequired}</div>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Devis */}
      {tab === 'devis' && (
        <div className="card">
          <div className="card-title">📋 {L('Mes demandes de devis', 'طلبات عروض الأسعار')} ({quotes.length})</div>
          {quotes.length === 0 ? (
            <div style={{ textAlign:'center', padding:'2rem', color:'var(--muted)' }}>
              <div style={{ fontSize:'2rem', marginBottom:'0.5rem' }}>📋</div>
              <p>{L('Aucune demande encore.','لا توجد طلبات بعد.')}</p>
              <button className="btn btn-primary" style={{ width:'auto', marginTop:'0.8rem' }} onClick={() => onNavigate('devis')}>{L('📋 Demander un devis','📋 طلب عرض أسعار')}</button>
            </div>
          ) : (
            <div>{quotes.map((q, i) => (
              <div key={i} style={{ padding:'0.8rem 0', borderBottom:'1px solid var(--border)' }}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'0.3rem' }}>
                  <div style={{ fontWeight:600, fontSize:'0.9rem' }}>{q.product_description}</div>
                  <span style={{ fontSize:'0.72rem', color:'var(--muted)' }}>{new Date(q.created_at).toLocaleDateString('fr-FR')}</span>
                </div>
                <div style={{ display:'flex', gap:'0.3rem', flexWrap:'wrap', marginBottom:'0.3rem' }}>
                  {q.hs_code && <span className="badge badge-blue">{q.hs_code}</span>}
                  <span className="badge badge-green">{q.origin_country} → {q.destination_port}</span>
                  {q.incoterm && <span className="badge badge-blue">{q.incoterm}</span>}
                  <span className={`badge ${q.status==='open'?'badge-yellow':'badge-green'}`}>{q.status==='open'?L('En attente','قيد الانتظار'):L('Répondu','تمت الإجابة')}</span>
                </div>
                {/* Full details */}
                <div style={{ fontSize:'0.78rem', color:'var(--muted)', display:'flex', gap:'1rem', flexWrap:'wrap', marginBottom:'0.4rem' }}>
                  {q.estimated_value_usd && <span>💰 ~${q.estimated_value_usd}</span>}
                  {q.estimated_weight_kg && <span>⚖️ ~{q.estimated_weight_kg}kg</span>}
                  {q.special_requirements && <span>📝 {q.special_requirements}</span>}
                </div>
                {/* Responses */}
                {q.quote_responses?.length > 0 && (
                  <div style={{ marginTop:'0.5rem' }}>
                    <div style={{ fontSize:'0.78rem', fontWeight:600, color:'#34d399', marginBottom:'0.3rem' }}>💼 {L(`${q.quote_responses.length} offre(s) reçue(s)`,`${q.quote_responses.length} عرض(عروض) مستلمة`)}</div>
                    {q.quote_responses.map((r, j) => (
                      <div key={j} style={{ background:'rgba(16,185,129,0.06)', border:'1px solid rgba(16,185,129,0.15)', borderRadius:10, padding:'0.8rem', marginBottom:'0.4rem' }}>
                        {r.freight_forwarders && <div style={{ fontSize:'0.85rem', fontWeight:600, marginBottom:'0.3rem' }}>🏢 {r.freight_forwarders.company_name}</div>}
                        <div style={{ fontWeight:600, fontSize:'0.88rem' }}>{L('Honoraires','الأتعاب')} : <span style={{color:'#34d399'}}>{r.estimated_fee}</span></div>
                        {r.estimated_delay && <div style={{ fontSize:'0.78rem', color:'var(--muted)' }}>{L('Délai','المدة')} : {r.estimated_delay}</div>}
                        {r.message && <div style={{ fontSize:'0.78rem', color:'var(--muted)', marginTop:'0.3rem', padding:'0.5rem', background:'rgba(255,255,255,0.02)', borderRadius:8 }}>💬 {r.message}</div>}
                        {r.freight_forwarders && <div style={{ marginTop:'0.4rem', fontSize:'0.78rem', background:'rgba(124,58,237,0.06)', borderRadius:8, padding:'0.5rem' }}>
                          📧 {r.freight_forwarders.email} {r.freight_forwarders.phone && `· 📱 ${r.freight_forwarders.phone}`}
                        </div>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}</div>
          )}
        </div>
      )}

      {/* Quick actions */}
      {tab === 'actions' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.7rem' }}>
          {[
            { icon: '📦', label: L('Analyse Import', 'تحليل استيراد'), page: 'analyse' },
            { icon: '🚢', label: L('Analyse Export', 'تحليل تصدير'), page: 'export' },
            { icon: '📄', label: L('Vérifier documents', 'تحقق من الوثائق'), page: 'verify' },
            { icon: '📊', label: L('Créer PPI', 'إنشاء PPI'), page: 'ppi' },
            { icon: '📋', label: L('Demander devis', 'طلب عرض أسعار'), page: 'devis' },
          ].map(a => (
            <div key={a.page} className="card" onClick={() => onNavigate(a.page)}
              style={{ cursor: 'pointer', textAlign: 'center', padding: '1.2rem', marginBottom: 0, transition: 'all 0.2s' }}
              onMouseOver={e => e.currentTarget.style.borderColor = '#7C3AED'}
              onMouseOut={e => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)'}>
              <div style={{ fontSize: '1.8rem', marginBottom: '0.3rem' }}>{a.icon}</div>
              <div style={{ fontSize: '0.82rem', fontWeight: 600 }}>{a.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
